module.exports = __webpack_public_path__ + "img/arrow-variations.2b116fc5.svg";